import { Message } from 'tplus-components-touch';

export class ControlSerialNumberProcessor {
    static async execute(dto) {
        //序列号存货必录序列号
        let details = dto.RetailDetails.filter((detail) => {
            if (detail.Inventory.IsSerialNumber && !detail.SerialNumber) {
                return true;
            }
            return false;
        });

        if (details.length > 0) {
            let codeArray = new Array();
            details.forEach(detail => {
                let rowNo = Number(detail.Code) + 1
                codeArray.push(rowNo);
            });
            let message = `以下行序列号不存在！：${InventoryInfo},请使用非原单退货！`;

            Message.warn(message.Format({ "InventoryInfo": codeArray.join(",") }));
            return false;
        }

        //退货
        if (dto.IdbusiType == 35) {
            //红蓝混录
            let bluedetail = dto.RetailDetails.find((detail, index) => {
                return detail.Inventory.IsSerialNumber && detail.Quantity > 0
            });

            if (bluedetail) {
                Message.warn('序列号商品不支持换货');
                return false;
            }
        }
        return true;
    }

}